
import ajax from '@fdaciuk/ajax'

class RegisterAlians {
  constructor() {

  }

  init() {
    // MW - get elements
    let form = document.querySelector('.js-register-alians-form');
    let submit = document.querySelector('.js-register-alians-submit');
    let image = document.querySelector('#mohito_alians_form_file');
    let notice =  document.querySelector('.notice');
    // MW - listeners
    if(form) {
      image.addEventListener('change', codeImageToBase64);
      submit.addEventListener('click', ajaxRegisterAlians);
      form.addEventListener('submit', (e) => {
        e.preventDefault();
      })

      //MW - code image to base64
      function codeImageToBase64() {
        let file = image.files[0];
        let reader = new FileReader();
        reader.onloadend = function() {
          let codedImage = reader.result;
          let base64 = document.querySelector('#base64');
          let preview = document.querySelector('.register-alians__image');

          base64.setAttribute('url', codedImage);
          preview.src=codedImage;
        }
        reader.readAsDataURL(file);
      }

      function ajaxRegisterAlians() {
        let formData = new FormData(form);
        let finalBase64Image = document.querySelector('#base64').getAttribute("url");
        formData.append('image', finalBase64Image);

        let result = Object.fromEntries(formData);
        let request = ajax(
          {
            method: 'POST',
            url: wp.ajaxregisteralians,
            data:
              {
                formData: result,
              }
          }
        )
        request.then(function(response) {
          notice.innerHTML = response;
        })
      }
    }
  }
}

export default new RegisterAlians();
